import { connect } from 'react-redux';

import HeaderPres from './HeaderPres';

const mapStateToProps = state => {
  return {
    isMobile: state.browser.is.small || state.browser.is.extraSmall,
    countInboxUnread: state.messaging.countInboxUnread,
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderPres);
